import React from 'react'

interface Props {
  message: string
}

export const ErrorMessage: React.FC<Props> = ({ message }) => (
  <p style={{ color: '#B6061D' }}>{message}</p>
)
